module.exports = __webpack_public_path__ + "static/media/grinning-face-svgrepo-com.1179a7ff.svg";